/**
 * `GET /gateway/api/assist/rovo/v1/pins`. Mirrors the `rovo-spaces` fetch-file convention (see
 * `useListSpaces.fetch.ts`'s `SPACES_API_PATH`): `credentials: 'include'` so the existing
 * authenticated session cookie is sent — this endpoint is never called anonymously.
 */
import { performHttpFetch } from '@atlassian/conversation-assistant-utils/httpUtils';

import type { PinType } from '../types';

const PINS_API_PATH = '/gateway/api/assist/rovo/v1/pins';

// Fixed per rovo-for-you/for-you-panel's own convention for this surface — see e.g.
// `useInsightsStatus`'s `experienceId: 'ai-mate'` call in for-you-panel/index.tsx.
const EXPERIENCE_ID = 'ai-mate';

/** A pin as returned by the backend. `name` is nullable — pins created before the backend
 * tracked a display name (or where it couldn't be resolved) have no name. */
export type Pin = {
	id: string;
	ari: string;
	url: string;
	pinType: PinType;
	name: string | null;
	createdAt: number;
};

export type ListPinsResponse = {
	data: Pin[];
};

export type PinsFetchContext = {
	cloudId: string;
	product?: string;
};

export const listPinsFetch = ({ cloudId, product }: PinsFetchContext): Promise<Pin[]> =>
	performHttpFetch<ListPinsResponse>({
		path: PINS_API_PATH,
		options: {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'x-cloudid': cloudId,
				'x-product': product ?? '',
				'x-experience-id': EXPERIENCE_ID,
			},
			credentials: 'include',
		},
	}).then((response) => response.data);
